
import { defineComponent } from "vue";

export default defineComponent({
  name: "NoLocationsTip",
  emits: {
    open: null,
  },
});
